import { useRef, useState } from 'react';
import { fetchSupportVehicle } from '../../../../api/tas';
import { AegVehicle } from '../../../../models/newAEG';

const useAegVehicle = () => {
    const [vehicle, setVehicle] = useState<AegVehicle | null>(null);
    const [isLoadingVehicle, setIsLoadingVehicle] = useState(false);
    const vehicleRequestId = useRef(0);

    const fetchVehicle = async (chassis: string): Promise<AegVehicle | null> => {
        const requestId = ++vehicleRequestId.current;
        setIsLoadingVehicle(true);

        const response: AegVehicle | null = await fetchSupportVehicle(chassis);
        if (requestId !== vehicleRequestId.current) {
            return null;
        }

        setVehicle(response);
        setIsLoadingVehicle(false);
        return response;
    };

    const resetVehicle = () => {
        vehicleRequestId.current += 1;
        setVehicle(null);
        setIsLoadingVehicle(false);
    };

    return { vehicle, isLoadingVehicle, fetchVehicle, resetVehicle };
};

export default useAegVehicle;
